module.exports = __webpack_public_path__ + "img/SA.55733f8f.webp";